import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import type headerLinks from '../assets/header/sv-se.json';
import { useGlobalLoading } from '../contexts/GlobalLoadingProvider';
import { useCountries } from './useCountries';

/** The header links */
export type HeaderLinks = typeof headerLinks;

type HeadersService = {
    /** The header links */
    headerLinks: HeaderLinks | undefined;
};

export const useHeaders = (): HeadersService => {
    const { incrementLoader, decrementLoader } = useGlobalLoading();
    const [links, setLinks] = useState<HeaderLinks | undefined>();
    const { countries } = useCountries();
    const { locale } = useIntl();

    const country = countries.find((c) => c.language === locale);

    const fetchData = () => {
        const aborter = new AbortController();

        const retrieve = () => {
            switch (locale) {
                default:
                case 'sv':
                    return import('../assets/header/sv-se.json');
                case 'nb':
                    return import('../assets/header/nb-no.json');
                case 'fi':
                    return import('../assets/header/fi-fi.json');
                case 'da':
                    return import('../assets/header/da-dk.json');
                case 'de':
                    return import('../assets/header/de-de.json');
            }
        };

        incrementLoader();
        retrieve()
            .then((header) => {
                aborter.signal.throwIfAborted();

                header.default.mainNavigation.forEach((l) => {
                    if (l.url.startsWith('/')) {
                        l.url = `${country?.urlNext}${l.url}`;
                    }
                });

                header.default.secondaryNavigation.forEach((l) => {
                    if (l.url.startsWith('/')) {
                        l.url = `${country?.urlNext}${l.url}`;
                    }
                });

                setLinks(header.default);
            })
            .finally(decrementLoader);

        return () => aborter.abort();
    };

    useEffect(fetchData, [incrementLoader, decrementLoader, locale, country?.urlNext]);

    return {
        headerLinks: links,
    };
};
